export default "* Spande eller poser\n* Evt. waders og redningsveste";